import Switch from "@ui/Switch";
import React from "react";
import OverlayWrapper from "@ui/TooltipV2/OverlayWrapper";
import t from "../../../../../i18n";
import { QuantitySelectorType } from "../../../QuantitySelector";
import { InformationLine } from "@ui/IconV2/react";
import TooltipV2 from "@ui/TooltipV2";
import { css } from "@linaria/core";
import { spacings } from "@ui/Theme";
import Text from "@ui/Text";

interface P {
  dataType: QuantitySelectorType;
  checked: boolean;
  onChange: () => void;
}

export const RelevantQuantitiesSwitch = ({ dataType, checked, onChange }: P) => (
  <Switch className={styledSwitch} checked={checked} onChange={onChange}>
    <Text>{t("project.fault_event.quantity_selector.switch.display_key_quantities.label")}</Text>
    <TooltipV2
      placement="top"
      overlay={
        <OverlayWrapper
          className={styledOverlayWrapper}
          text={
            <div>
              {!checked && dataType === QuantitySelectorType.Measures
                ? t(
                    "project.fault_event.quantity_selector.switch.display_key_quantities.on.tooltip.text",
                  )
                : t(
                    "project.fault_event.quantity_selector.switch.display_key_quantities.off.tooltip.text",
                  )}
            </div>
          }
        />
      }
    >
      <span className={centerIcon}>
        <InformationLine />
      </span>
    </TooltipV2>
  </Switch>
);

const styledSwitch = css`
  & > span {
    display: flex;
    align-items: center;
  }
`;
const styledOverlayWrapper = css`
  max-width: 350px;
`;
const centerIcon = css`
  padding-left: ${spacings.xxs};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
